module.exports = __webpack_public_path__ + "media/apps/mitch-android-6-7a9bc9e0.png";